module.exports = "/_next/static/images/bg8-2a0ec48394a025c8cbb03bb9bf5a821b.jpg";